export default "__VITE_ASSET__BXh4hE$$__"